import { type RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/constants'
import Confidentiality from '@/views/docs/Confidentiality.vue'
import List from '@/views/docs/List.vue'
import Personal from '@/views/docs/Personal.vue'
import Terms from '@/views/docs/Terms.vue'
import Docs from '@/views/Docs.vue'
import Home from '@/views/Home.vue'
import NotFound from '@/views/NotFound.vue'

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: Home,
        name: ROUTES.HOME,
    },
    {
        path: '/docs',
        component: Docs,
        name: ROUTES.DOCS,
        children: [
            {
                path: '/docs',
                component: List,
                name: ROUTES.DOCLIST,
                meta: { title: 'Список документов' },
            },
            {
                path: '/docs/confidentiality',
                component: Confidentiality,
                name: ROUTES.CONFIDENTIALITY,
                meta: { title: 'Политика конфиденциальности' },
            },
            {
                path: '/docs/personal-data',
                component: Personal,
                name: ROUTES.PERSONAL,
                meta: { title: 'Согласие на обработкуp персональных данных' },
            },
            {
                path: '/docs/usage-terms',
                component: Terms,
                name: ROUTES.TERMS,
                meta: { title: 'Условия использование' },
            },
        ],
    },
    {
        path: '/404',
        component: NotFound,
        name: ROUTES.NOT_FOUND,
        meta: { title: 'Страница не найдена' },
    },
    {
        path: '/:path(.*)',
        component: NotFound,
        meta: { title: 'Страница не найдена' },
    },
]
